import { useLocation } from "react-router-dom";
import { useGetPostQuery } from "../../../../store/api/homeApi";
import FeedCard from "../feed/feed-card";
import { useEffect, useState } from "react";

import { BtnLoader } from "../../../../icons";
import { MODAL_NAME } from "../../../../constants";
import ReportFeed from "../feed/report-feed";
import { useAppSelector } from "../../../../hooks/store-hooks";
import CreateFeed from "../feed/create-feed";
import DeletePost from "../feed/delete-feed";

const ActivityContent = () => {
  const location = useLocation();
  const activityId = location.pathname.split("/").pop();
  const { modalName, isModalOpen } = useAppSelector(
    (state: any) => state.modal ?? {},
  );
  const {
    data: activityData,
    isFetching,
    refetch: refetchUserPostData,
  } = useGetPostQuery(activityId);

  const [isFollow, setIsFollow] = useState<{ [key: string]: boolean }>({});

  useEffect(() => {
    setIsFollow((prev) => ({
      ...prev,
      [activityData?.post?.user?.id]: activityData?.post?.user?.is_follows,
    }));
  }, [activityData]);

  return (
    <div className="w-full lg:col-span-6 h-[calc(100vh-7rem)] overflow-y-auto">
      {isFetching && <BtnLoader />}
      {activityData && !isFetching && (
        <FeedCard
          showCommentDefault={true}
          postData={activityData.post}
          follow={isFollow[activityData?.post?.user?.id]}
          setIsFollow={(followStatus: boolean) =>
            setIsFollow((prev) => ({
              ...prev,
              [activityData?.post?.user?.id]: followStatus,
            }))
          }
        />
      )}
      {modalName === MODAL_NAME.REPORT ? <ReportFeed /> : <></>}
      {modalName === MODAL_NAME.CREATE_POST && isModalOpen && (
        <CreateFeed
          activityId={activityId}
          refetchUserPostData={refetchUserPostData}
        />
      )}
      {modalName === MODAL_NAME.DELETE_POST ? (
        <DeletePost activityId={activityId} />
      ) : (
        <></>
      )}
    </div>
  );
};

export default ActivityContent;
